module.exports = __webpack_public_path__ + "static/media/right.e1c5e17f.svg";